<eqa-logo></eqa-logo>
<eqa-profile [userId]="userId"></eqa-profile>
